( function( $ ) {

	$( document ).ready( function() {

		function toggleHeaderClass() {
			if ( $( window ).scrollTop() > 0 ) {
				$( "#header" ).addClass( "fixed" );
			} else {
				$( "#header" ).removeClass( "fixed" );
			}
		}

		$( window ).on( "scroll resize load", function() {
			toggleHeaderClass();
		} );

		//on mobile, when menu link is clicked, the leftslide menu should be closed.
		$( "#header ul.wp-menu-area li a" ).on( "click", function() {
			$( "html" ).removeClass( 'nav-open' );
			$( "[data-mobile-menu]" ).removeClass( 'open' );
		} );

	} );


} )( jQuery )